import { MdrCustomerPanelView } from '../view/MdrCustomerPanelView';
import { templateMdrCustomerPanel } from '../view/template';
import { MdrCustomerPanelRepository } from '../repository/MdrCustomerPanelRepository';
import { BaseWebComponentController, IListenerConfig } from '../../../framework/BaseWebComponentController';
import { MdrCustomerPanelWebComponent } from '..';
import { CompanyData } from '../../../company/types/company-data';
import { showErrorToast } from '@nirvana/shared/common';
import { translateFn } from '../../../utils/translator.helper';

export class MdrCustomerPanelController extends BaseWebComponentController {
  public component: MdrCustomerPanelWebComponent;
  public dataRepository: MdrCustomerPanelRepository;
  public view: MdrCustomerPanelView;
  public viewConstructor: typeof MdrCustomerPanelView;
  public dataRepositoryConstructor: typeof MdrCustomerPanelRepository;

  constructor(component: MdrCustomerPanelWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: MdrCustomerPanelView,
      viewTemplate: templateMdrCustomerPanel,
      dataRepositoryConstructor: MdrCustomerPanelRepository,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$openConsoleButton,
        event: 'click',
        callback: this.handleOpenMdrConsole,
      },
    ];
  }

  async getDataForView(): Promise<CompanyData> {
    return await this.dataRepository.getMyCompanyData();
  }

  private async handleOpenMdrConsole() {
    try {
      await this.openMdrConsoleForCurrentUser();
    } catch (error) {
      showErrorToast(error);
    }
  }

  private async openMdrConsoleForCurrentUser(): Promise<void> {
    const errorMessage = translateFn('Unexpected error occurred while opening the MDR console.');
    let response;

    try {
      response = await this.dependencies.api.clients.Mdr.openConsole().toPromise();
    } catch (error) {
      throw new Error(errorMessage);
    }

    if (!response || !response.success) {
      throw new Error(errorMessage);
    }
  }
}
